import * as Yup from 'yup'

const productCollectionScheme = Yup.object().shape({
  name               : Yup.string().required('name required'),
  url                : Yup.string().required('url required'),
  is_standalone_page : Yup.string().required('Is standalone page required')
})

export default productCollectionScheme
